import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SharedModule} from "../shared/shared.module";
import {DefiniceVykazuDataService} from "./definice-vykazu-data.service";


@NgModule
({
  declarations : [],
  imports :
    [
      CommonModule,
      SharedModule
    ],
  providers :
    [
      {
        provide : DefiniceVykazuDataService, useClass : DefiniceVykazuDataService, multi : false
      },
    ]
})
export class DefiniceVykazuDataModule{}
